import { SetupWizard, goToAdminSignIn } from '@matix/ui';
import { useLang } from '../../lib/lang';
import { useAuthStore } from '../../lib/authStore';

/**
 * A newly provisioned tenant's first sign-in on the appointments desk: the
 * shared Initial Setup Wizard. Finishing it opens the ADMIN app's sign-in.
 */
export function SetupScreen(): JSX.Element | null {
  const setup = useAuthStore((s) => s.setup);
  const exitSetup = useAuthStore((s) => s.exitSetup);
  const { lang, setLang } = useLang();
  if (!setup) return null;
  return (
    <SetupWizard
      tenantSlug={setup.slug}
      tenantName={setup.tenantName}
      setupToken={setup.setupToken}
      lang={lang}
      onLangChange={setLang}
      apiBase={(import.meta.env.VITE_API_BASE_URL ?? '') as string}
      continueLabel={{ en: 'Go to the admin dashboard', ar: 'الانتقال إلى لوحة الإدارة' }}
      // Setting a business up is admin work: finish in the admin app.
      onComplete={() => goToAdminSignIn(setup.slug)}
      onExit={exitSetup}
    />
  );
}
